var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Access Invitation ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              {
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("gg-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    }
                  ],
                  attrs: {
                    outlined: "",
                    label: "Email",
                    name: "Email",
                    "error-messages": _vm.errors.collect("Email")
                  },
                  model: {
                    value: _vm.email,
                    callback: function callback($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _c("gg-select", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    dense: "",
                    outlined: "",
                    label: "Select a service",
                    items: _vm.serviceList,
                    name: "Service",
                    "item-text": _vm.serviceText,
                    "item-value": "id",
                    "error-messages": _vm.errors.collect("Service")
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function fn(_ref) {
                        var item = _ref.item
                        return [
                          _vm._v(" " + _vm._s(item.name)),
                          item.domain
                            ? [_vm._v(": " + _vm._s(item.domain))]
                            : _vm._e()
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.service,
                    callback: function callback($$v) {
                      _vm.service = $$v
                    },
                    expression: "service"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.invite
                }
              },
              [
                _vm._v(" Invite "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v("button")]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }